import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { IconButton } from '@/components/icon-button/IconButton'
import { MenuContent, MenuItemGroup } from '@/components/menu/MenuContent'
import { MenuItem } from '@/components/menu/MenuItem'
import { OverflowMenu, Edit, MoveToFolder, TrashDelete } from '@/assets/icons'

interface FolderOverflowMenuProps {
  onRename?: () => void
  onMove?: () => void
  onDelete?: () => void
}

/**
 * FolderOverflowMenu
 *
 * Dropdown menu for folder actions (rename, move, delete).
 */
export function FolderOverflowMenu({ onRename, onMove, onDelete }: FolderOverflowMenuProps) {
  if (!onRename && !onMove && !onDelete) return null

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <IconButton icon={<OverflowMenu />} variant="plain" color="neutral" aria-label="Folder actions" />
      </DropdownMenu.Trigger>

      <MenuContent align="end" alignOffset={-3} side="bottom">
        <MenuItemGroup>
          {onDelete && <MenuItem label="Delete" icon={TrashDelete} onSelect={onDelete} variant="destructive" />}
          {onRename && <MenuItem label="Rename" icon={Edit} onSelect={onRename} variant="neutral" />}
          {onMove && <MenuItem label="Move" icon={MoveToFolder} onSelect={onMove} variant="neutral" />}
        </MenuItemGroup>
      </MenuContent>
    </DropdownMenu.Root>
  )
}
